<div class="detail-container">

  <!-- HEADER -->
  <div class="page-header">
    <div class="header-left">

      <button mat-icon-button type="button" (click)="back()" matTooltip="Zurück zur Messstellenliste">
        <mat-icon>arrow_back</mat-icon>
      </button>

      <div>
        <h1 class="page-title">Inbetriebnahme Messstelle</h1>

        <div class="page-sub" *ngIf="messstelle?.messstellenListeName">
          {{ messstelle?.messstellenListeName }}

          · {{ kopfdaten[0].value }}



          <ng-container *ngIf="messstelle?.customerName">
            · {{ messstelle?.customerName }}
          </ng-container>
        </div>

        <!-- Projekt der Messstelle, falls die Liste einem zugeordnet ist -->
        <button type="button" class="projekt-chip" *ngIf="messstelle?.projektId" (click)="oeffneProjekt()"
          matTooltip="Projekt öffnen">

          <mat-icon>folder_special</mat-icon>

          <span class="projekt-nummer" *ngIf="messstelle?.projektNummer">
            {{ messstelle?.projektNummer }}
          </span>

          <span>{{ messstelle?.projektName }}</span>
        </button>
      </div>

    </div>
    <div class="header-actions" *ngIf="messstelle && canEdit">

      <button *ngIf="canEdit" mat-stroked-button type="button" [disabled]="qrStatusLoading" (click)="qrCodeVergeben()">

        <mat-icon>

          {{
          hatAktivenQr
          ? 'published_with_changes'
          : 'qr_code_scanner'
          }}

        </mat-icon>


        {{
        qrStatusLoading

        ? 'QR-Code wird geprüft...'

        : (
        hatAktivenQr
        ? 'QR-Code ersetzen'
        : 'QR-Code vergeben'
        )
        }}

      </button>

      <!-- Die Zuordnung ist auf dem Gerät gespeichert, aber noch nicht am Server. -->
      <span class="status-badge status-badge--warning" *ngIf="qrWartend"
        matTooltip="Die QR-Zuordnung wurde ohne Verbindung erfasst und wird bei der nächsten Synchronisierung abgeglichen.">
        <mat-icon inline>cloud_upload</mat-icon>
        QR wartet auf Synchronisierung
      </span>

    </div>
  </div>


  <!--
    OFFLINE-HINWEIS

    Bearbeiten geht weiter: Ergebnisse, Bemerkungen, Signalstatus und
    Gesamtergebnis werden lokal gespeichert und gehen bei der nächsten
    Verbindung hinaus. Nur die Fotos brauchen den Server – ihre Bilddaten
    liegen bewusst nicht auf dem Gerät.
  -->
  <mat-card class="offline-banner" *ngIf="istOffline && !isLoading">
    <mat-card-content>
      <mat-icon>cloud_off</mat-icon>
      <span>
        Offline-Daten · Stand {{ standUtc | date:'dd.MM.yyyy HH:mm' }} ·
        Änderungen werden lokal gespeichert und bei Verbindung synchronisiert.
        Fotos stehen ohne Verbindung nicht zur Verfügung.
      </span>
    </mat-card-content>
  </mat-card>


  <!-- LOADING -->
  <div class="loading" *ngIf="isLoading">
    <mat-spinner diameter="40"></mat-spinner>
  </div>


  <!-- FEHLER -->
  <mat-card class="hint-card" *ngIf="loadError">
    <mat-card-content>
      {{ loadError }}
    </mat-card-content>
  </mat-card>


  <!-- INHALT -->
  <ng-container *ngIf="!isLoading && messstelle">


    <!-- =====================================================
         1. ALLGEMEINE DATEN
         ===================================================== -->
    <mat-card class="section-card">

      <mat-card-content>
        <h2 class="section-title">
          <span class="section-number">1</span>
          Allgemeine Daten

          <!-- Bearbeiten: die Anzeige bleibt Text, bis hier umgeschaltet wird -->
          <span class="section-actions" *ngIf="canEdit">

            <button mat-stroked-button type="button" *ngIf="!bearbeiten" (click)="starteBearbeitung()">
              <mat-icon>edit</mat-icon>
              Bearbeiten
            </button>

            <ng-container *ngIf="bearbeiten">

              <button mat-raised-button color="primary" type="button" [disabled]="savingWerte"
                (click)="speichereWerte()">
                <mat-icon>save</mat-icon>
                Speichern
              </button>

              <button mat-button type="button" [disabled]="savingWerte" (click)="brichBearbeitungAb()">
                Abbrechen
              </button>

              <mat-spinner diameter="20" *ngIf="savingWerte"></mat-spinner>

            </ng-container>

          </span>
        </h2>


        <!--
          Kompakte Stammdaten:
          Kennzeichnung (KKS / AKZ / SKS / ...) und Langtext bleiben immer sichtbar.
          Alle weiteren Informationen liegen in einem aufklappbaren Bereich.
        -->
        <div class="kopfdaten kopfdaten-kompakt" *ngIf="kopfdatenKompakt.length > 0">

          <div class="kopf-eintrag" *ngFor="let kopf of kopfdatenKompakt; trackBy: trackByKopf"
            [class.kopf-eintrag-kennz]="kopf.kennzeichnung">

            <div class="kopf-label">
              <mat-icon class="kopf-kennz-icon" inline *ngIf="kopf.kennzeichnung">key</mat-icon>
              {{ kopf.label }}
            </div>

            <!-- Anzeige -->
            <div class="kopf-wert" *ngIf="!bearbeiten" [class.kopf-wert-leer]="kopf.value === leerPlatzhalter">
              {{ kopf.value }}
            </div>

            <!-- Bearbeitung -->
            <div class="kopf-eingaben" *ngIf="bearbeiten">
              <ng-container *ngFor="let feld of kopf.felder; let i = index">
                <ng-container *ngTemplateOutlet="kopfEingabe; context: { kopf: kopf, i: i }"></ng-container>
              </ng-container>
            </div>

          </div>

        </div>


        <!--
          Eingabefeld je Datentyp. Importierte Listen kennen nur Text; bei
          manuell erstellten Listen bestimmt die Spaltenstruktur den Typ.
        -->
        <ng-template #kopfEingabe let-kopf="kopf" let-i="i">

          <ng-container [ngSwitch]="kopf.typ">

            <input *ngSwitchCase="'Datum'" class="kopf-input" type="date"
              [attr.aria-label]="kopf.label + ' ' + kopf.eingabeLabels[i]"
              [disabled]="savingWerte" [(ngModel)]="kopf.eingaben[i]" />

            <select *ngSwitchCase="'JaNein'" class="kopf-input"
              [attr.aria-label]="kopf.label + ' ' + kopf.eingabeLabels[i]"
              [disabled]="savingWerte" [(ngModel)]="kopf.eingaben[i]">
              <option value="">— nicht gesetzt —</option>
              <option value="Ja">Ja</option>
              <option value="Nein">Nein</option>
            </select>

            <input *ngSwitchCase="'Zahl'" class="kopf-input" type="text" inputmode="decimal"
              [attr.aria-label]="kopf.label + ' ' + kopf.eingabeLabels[i]" [placeholder]="kopf.eingabeLabels[i]"
              [disabled]="savingWerte" [(ngModel)]="kopf.eingaben[i]" />

            <input *ngSwitchDefault class="kopf-input" type="text"
              [attr.aria-label]="kopf.label + ' ' + kopf.eingabeLabels[i]" [placeholder]="kopf.eingabeLabels[i]"
              [disabled]="savingWerte" [(ngModel)]="kopf.eingaben[i]" />

          </ng-container>

        </ng-template>


        <!-- Weitere Daten auf-/zuklappen -->
        <button mat-button type="button" class="weitere-daten-toggle" *ngIf="hatWeitereAllgemeineDaten"
          (click)="weitereAllgemeineDatenOffen = !weitereAllgemeineDatenOffen"
          [attr.aria-expanded]="weitereAllgemeineDatenOffen">

          <mat-icon>
            {{ weitereAllgemeineDatenOffen ? 'expand_less' : 'expand_more' }}
          </mat-icon>

          {{
          weitereAllgemeineDatenOffen
          ? 'Weitere Daten ausblenden'
          : 'Weitere Daten anzeigen'
          }}

        </button>


        <!-- Alle übrigen Stammdaten -->
        <div class="weitere-allgemeine-daten" *ngIf="weitereAllgemeineDatenOffen">

          <div class="kopfdaten" *ngIf="kopfdatenDetails.length > 0">

            <div class="kopf-eintrag" *ngFor="let kopf of kopfdatenDetails; trackBy: trackByKopf">

              <div class="kopf-label">{{ kopf.label }}</div>

              <!-- Anzeige -->
              <div class="kopf-wert" *ngIf="!bearbeiten" [class.kopf-wert-leer]="kopf.value === leerPlatzhalter">
                {{ kopf.value }}
              </div>

              <!-- Bearbeitung: eine Eingabe je Feld, bei Spannen zwei; Typ aus der Struktur -->
              <div class="kopf-eingaben" *ngIf="bearbeiten">
                <ng-container *ngFor="let feld of kopf.felder; let i = index">
                  <ng-container *ngTemplateOutlet="kopfEingabe; context: { kopf: kopf, i: i }"></ng-container>
                </ng-container>
              </div>

            </div>

          </div>


          <!--
            Sonstige relevante Originalspalten aus Excel, die keinem der
            Standardfelder oben entsprechen. Sie bleiben rein lesend.
          -->
          <ng-container *ngIf="weitereDaten.length > 0">

            <div class="weitere-excel-titel">
              {{ istManuelleListe ? 'Weitere Daten' : 'Weitere Excel-Daten' }}
            </div>

            <div class="kopfdaten weitere-excel-daten">

              <div class="kopf-eintrag" *ngFor="let kopf of weitereDaten; trackBy: trackByKopf">

                <div class="kopf-label">{{ kopf.label }}</div>

                <div class="kopf-wert">
                  {{ kopf.value }}
                </div>

              </div>

            </div>

          </ng-container>

        </div>


      </mat-card-content>

    </mat-card>


    <!-- =====================================================
         2. PRÜFUNG

         Kategorie, Signalstatus, Prüfergebnis und Fortschritt
         stehen bewusst zusammen: Signalstatus (Bearbeitungs-
         zustand), Prüfergebnis (fachliches Urteil) und
         Fortschritt (wie viel schon geprüft wurde) sind drei
         verschiedene Dinge.
         ===================================================== -->
    <mat-card class="section-card">

      <mat-card-content>

        <h2 class="section-title">
          <span class="section-number">2</span>
          Prüfung
        </h2>


        <div class="pruefung-row">

          <!--
            KATEGORIE

            Gemeinsame Auswahl mit Beschreibung je Option und Vorschau der
            Prüfpunkte (Hover, Pfeiltasten, Info-Symbol). Die Struktur kommt
            mit den Kategorien – online wie offline kein Nachladen.
          -->
          <app-kategorie-auswahl
            class="kategorie-field"
            data-wizard-target="detail-kategorie"
            [kategorien]="kategorien"
            [value]="selectedKategorieId"
            (valueChange)="onKategorieChange($event)"
            [disabled]="!canEdit || savingKategorie"
            hint="Bestimmt, welche Prüfpunkte abzuarbeiten sind.">
          </app-kategorie-auswahl>


          <!--
            ANLAGENTEIL

            Reine Gruppierung für Suche, Filter und spätere Auswertungen –
            ohne Einfluss auf Prüfpunkte oder Ergebnisse. Nur sichtbar, wenn
            die Liste überhaupt Anlagenteile führt; ohne Netz ausgegraut,
            weil es dafür keinen Offline-Änderungstyp gibt.
          -->
          <mat-form-field appearance="outline" class="kategorie-field" *ngIf="anlagenteile.length > 0 || !istOffline">

            <mat-label>Anlagenteil</mat-label>

            <mat-select [value]="selectedAnlagenteilId" (selectionChange)="onAnlagenteilChange($event.value)"
              [disabled]="!canEdit || savingAnlagenteil || istOffline">

              <mat-option [value]="null">
                — keine Zuordnung —
              </mat-option>

              <!--
                Gespeicherte Zuordnung zu einem Anlagenteil außerhalb dieses
                Projekts: sichtbar, aber nicht wählbar. Die Auswahl darunter
                enthält ausschließlich Anlagenteile des Projekts; was der
                Benutzer hier wählt, ersetzt den fremden Verweis bewusst.
              -->
              <mat-option *ngIf="messstelle?.anlagenteilFremd && selectedAnlagenteilId !== null"
                [value]="selectedAnlagenteilId" disabled>
                {{ messstelle!.anlagenteilName || 'Anlagenteil' }} (nicht in diesem Projekt)
              </mat-option>

              <mat-option *ngFor="let a of anlagenteile" [value]="a.id">

                {{ a.name }}

              </mat-option>

            </mat-select>

            <mat-hint *ngIf="!istOffline && messstelle?.anlagenteilFremd" class="hint-warnung">
              Der gespeicherte Anlagenteil gehört zu einem anderen Projekt. Bitte einen Anlagenteil dieses Projekts wählen oder die Zuordnung entfernen.
            </mat-hint>

            <mat-hint *ngIf="!istOffline && !messstelle?.anlagenteilFremd">
              Gruppiert die Messstelle für Filter und Auswertungen.
            </mat-hint>

            <mat-hint *ngIf="istOffline">
              Ohne Netz nicht änderbar.
            </mat-hint>

          </mat-form-field>


          <!--
            NEUER ANLAGENTEIL

            Vor Ort fällt oft erst auf, dass eine Gruppe fehlt. Den Umweg
            über den Importdialog zu verlangen wäre die falsche Reihenfolge.
          -->
          <div class="anlagenteil-neu" *ngIf="canEdit && !istOffline">

            <button mat-button type="button" *ngIf="!neuerAnlagenteilOffen" (click)="neuerAnlagenteilOffen = true">

              <mat-icon>add</mat-icon>
              Neuer Anlagenteil

            </button>

            <ng-container *ngIf="neuerAnlagenteilOffen">

              <mat-form-field appearance="outline" class="kategorie-field">
                <mat-label>Name des Anlagenteils</mat-label>
                <input matInput [(ngModel)]="neuerAnlagenteilName" placeholder="z.B. Absackanlage"
                  (keyup.enter)="neuenAnlagenteilAnlegen()">
              </mat-form-field>

              <button mat-stroked-button color="primary" type="button"
                [disabled]="!neuerAnlagenteilName.trim() || savingAnlagenteil" (click)="neuenAnlagenteilAnlegen()">
                Anlegen
              </button>

              <button mat-button type="button" (click)="neuerAnlagenteilOffen = false; neuerAnlagenteilName = ''">
                Abbrechen
              </button>

            </ng-container>

          </div>


          <!-- SIGNALSTATUS: Bearbeitungszustand der Messstelle -->
          <mat-form-field appearance="outline" class="signalstatus-field">

            <mat-label>Signalstatus</mat-label>

            <mat-select [value]="selectedSignalStatus" (selectionChange)="onSignalStatusChange($event.value)"
              [disabled]="!canEdit || savingSignalStatus || savingKategorie">

              <mat-option *ngFor="let opt of signalStatusOptionen" [value]="opt.wert">

                {{ opt.text }}

              </mat-option>

            </mat-select>

            <mat-hint>
              Bearbeitungszustand – nicht das Prüfergebnis.
            </mat-hint>

          </mat-form-field>


          <!-- PRÜFERGEBNIS: fachliches Gesamturteil -->
          <mat-form-field appearance="outline" class="pruefergebnis-field">

            <mat-label>Prüfergebnis</mat-label>

            <mat-select [value]="selectedPruefergebnis" (selectionChange)="onPruefergebnisChange($event.value)"
              [disabled]="!canEdit || savingPruefergebnis || savingKategorie">

              <mat-option *ngFor="let opt of pruefergebnisOptionen" [value]="opt.wert">

                {{ opt.text }}

              </mat-option>

            </mat-select>

            <mat-hint>
              Gilt für die ganze Messstelle.
            </mat-hint>

          </mat-form-field>


          <!-- Wird gespeichert -->
          <div class="kategorie-saving" *ngIf="savingKategorie || savingSignalStatus || savingPruefergebnis">

            <mat-spinner diameter="22"></mat-spinner>

            <span *ngIf="savingKategorie">
              Prüfpunkte werden geladen …
            </span>

            <span *ngIf="!savingKategorie">
              wird gespeichert …
            </span>

          </div>


          <!-- FORTSCHRITT: nur, wie viel geprüft wurde -->
          <div class="fortschritt-box" *ngIf="gesamt > 0">

            <div class="fortschritt-zahlen">

              <span class="chip offen" *ngIf="offen > 0">
                {{ offen }} nicht geprüft
              </span>

              <span class="chip bestanden" *ngIf="bestanden > 0">
                {{ bestanden }} bestanden
              </span>

              <span class="chip nichtbestanden" *ngIf="nichtBestanden > 0">
                {{ nichtBestanden }} nicht bestanden
              </span>

              <span class="chip irrelevant" *ngIf="irrelevant > 0">
                {{ irrelevant }} irrelevant
              </span>

            </div>

            <mat-progress-bar mode="determinate" [value]="fortschrittProzent">
            </mat-progress-bar>

            <div class="fortschritt-text">
              {{ abgearbeitet }} / {{ gesamt }}
              · {{ fortschrittProzent }} % abgearbeitet
            </div>

          </div>

        </div>


        <!--
          NOTIZ ZUR MESSSTELLE

          Freiwillig und unabhängig vom Prüfergebnis: kein Pflichthinweis,
          kein Stern, nichts, was das Speichern aufhält. Eine verpflichtende
          Fehlerbeschreibung gibt es nur am einzelnen Prüfpunkt.
        -->
        <mat-form-field appearance="outline" class="gesamt-bemerkung-field">

          <mat-label>
            Notiz zur Messstelle
          </mat-label>

          <textarea matInput rows="2" [(ngModel)]="messstelleNotiz"
            [disabled]="!canEdit || savingNotiz || savingKategorie" (blur)="saveMessstelleNotiz()"
            placeholder="z.B. Zugang nur über Leiter, Schlüssel beim Pförtner."></textarea>

          <mat-hint>
            Allgemeine Notiz zur Messstelle. Optional und unabhängig vom
            Prüfergebnis.
          </mat-hint>

        </mat-form-field>

        <!--
          SCHNELLPRÜFUNG

          Eigene Zeile mit Trennlinie: die Aktion betrifft alle
          Prüfpunkte und ist keine weitere Angabe im Formular darüber.
        -->
        <div class="schnell-pruefung-zeile">

          <button mat-stroked-button color="primary" type="button" class="schnell-pruefung-btn" [disabled]="
              !canEdit ||
              schnellPruefungLaeuft ||
              savingKategorie ||
              gesamt === 0
            " (click)="schnellPruefung()">

            <mat-spinner *ngIf="schnellPruefungLaeuft" diameter="18">
            </mat-spinner>

            <ng-container *ngIf="!schnellPruefungLaeuft">
              <mat-icon>done_all</mat-icon>
              Schnell Prüfung
            </ng-container>

          </button>

          <p class="schnell-pruefung-hinweis">
            Setzt jeden Prüfpunkt auf „Bestanden“.
          </p>

        </div>

      </mat-card-content>

    </mat-card>



    <!-- =====================================================
         KEINE KATEGORIE / KEINE PRÜFPUNKTE
         ===================================================== -->
    <mat-card class="hint-card" *ngIf="sections.length === 0" data-wizard-target="detail-pruefpunkte">

      <mat-card-content>

        <p *ngIf="!messstelle.kategorieId">
          Dieser Messstelle ist noch keine Kategorie zugeordnet.
          Sobald eine Kategorie gewählt wurde, werden deren
          Prüfpunkte automatisch angelegt.
        </p>

        <p *ngIf="messstelle.kategorieId">
          Für diese Kategorie sind aktuell keine Prüfpunkte hinterlegt.
        </p>

      </mat-card-content>

    </mat-card>


    <!-- =====================================================
         PRÜFPUNKTE NACH ABSCHNITT
         ===================================================== -->
    <mat-card class="section-card" *ngFor="
        let section of sections;
        let i = index;
        trackBy: trackBySection
      ">

      <mat-card-content>

        <h2 class="section-title">

          <span class="section-number">
            {{ i + 3 }}
          </span>

          {{ section.name }}

        </h2>


        <!-- EINZELNER PRÜFPUNKT -->
        <div class="punkt" *ngFor="
            let punkt of section.punkte;
            let ersterPunkt = first;
            trackBy: trackByPunkt
          " [attr.data-wizard-target]="i === 0 && ersterPunkt ? 'detail-pruefpunkte' : null"
          [class.punkt-bestanden]="ergebnisVon(punkt) === Ergebnis.Bestanden"
          [class.punkt-nichtbestanden]="ergebnisVon(punkt) === Ergebnis.NichtBestanden"
          [class.punkt-irrelevant]="ergebnisVon(punkt) === Ergebnis.Irrelevant"
          [class.punkt-saving]="isSaving(punkt.id)">


          <!-- Kopf -->
          <div class="punkt-head">

            <div class="punkt-info">

              <span class="punkt-text">
                {{ punkt.bezeichnung }}
              </span>

              <!--
                Noch nicht beim Server. Bewusst ein neutrales Symbol und kein
                Warndreieck: die Änderung ist gespeichert, sie ist nur noch
                unterwegs.
              -->
              <mat-icon class="punkt-nicht-synchronisiert" *ngIf="istNichtSynchronisiert(punkt)"
                matTooltip="Lokal gespeichert – wird bei Verbindung synchronisiert">
                cloud_queue
              </mat-icon>

              <span class="punkt-manuell" *ngIf="isManuell(punkt)">

                <mat-icon>edit_note</mat-icon>
                eigener Prüfpunkt

              </span>

            </div>


            <div class="punkt-actions">

              <mat-spinner diameter="20" *ngIf="isSaving(punkt.id)">
              </mat-spinner>


              <!--
                PRÜFERGEBNIS: ein echtes Ergebnis statt nur "erledigt".
                Nicht geprüft · Bestanden · Nicht bestanden · Irrelevant
              -->
              <div class="ergebnis-buttons">

                <button *ngFor="let opt of ergebnisOptionen" mat-stroked-button type="button" class="ergebnis-btn"
                  [ngClass]="opt.css" [class.aktiv]="ergebnisVon(punkt) === opt.wert" [disabled]="
                    !canEdit ||
                    isSaving(punkt.id) ||
                    savingKategorie
                  " [matTooltip]="opt.text" (click)="setErgebnis(punkt, opt.wert)">

                  <mat-icon>
                    {{ opt.icon }}
                  </mat-icon>

                  {{ opt.text }}

                </button>

              </div>


              <!-- Löschen: nur eigene Punkte -->
              <button mat-icon-button type="button" *ngIf="isManuell(punkt) && canEdit" [disabled]="
                  isSaving(punkt.id) ||
                  savingKategorie
                " (click)="deletePunkt(punkt)" matTooltip="Eigenen Prüfpunkt entfernen">

                <mat-icon>
                  delete_outline
                </mat-icon>

              </button>

            </div>

          </div>


          <!--
            BEMERKUNG bzw. FEHLERBESCHREIBUNG.
            Dasselbe Feld, nur anders beschriftet: bei "nicht bestanden"
            ist es Pflicht, sonst optional.
          -->
          <mat-form-field appearance="outline" class="bemerkung-field"
            [class.bemerkung-pflicht]="fehlerbeschreibungFehlt(punkt)">

            <mat-label>
              {{ bemerkungLabel(punkt) }}
            </mat-label>

            <input matInput [(ngModel)]="punkt.bemerkung" [disabled]="
                !canEdit ||
                isSaving(punkt.id) ||
                savingKategorie
              " (blur)="saveBemerkung(punkt)" [placeholder]="
                brauchtFehlerbeschreibung(punkt)
                  ? 'z.B. Kabel am Sensor nicht korrekt angeschlossen'
                  : 'z.B. warum nicht relevant'
              " />

          </mat-form-field>


          <p class="pflicht-hinweis" *ngIf="fehlerbeschreibungFehlt(punkt)">

            <mat-icon>error_outline</mat-icon>

            Bei „Nicht bestanden“ ist eine Fehlerbeschreibung erforderlich –
            das Ergebnis wird erst danach gespeichert.

          </p>


          <!-- QUITTIERUNG -->
          <div class="quittierung" *ngIf="punkt.quittiertAmUtc">

            <mat-icon>
              history
            </mat-icon>

            zuletzt geprüft
            {{ punkt.quittiertAmUtc | date:'dd.MM.yyyy HH:mm' }}

            <ng-container *ngIf="punkt.quittiertVon">
              durch {{ punkt.quittiertVon }}
            </ng-container>

          </div>

        </div>

      </mat-card-content>

    </mat-card>


    <!-- =====================================================
         EIGENEN PRÜFPUNKT HINZUFÜGEN
         ===================================================== -->
    <mat-card class="section-card" *ngIf="canEdit">

      <mat-card-content>

        <h2 class="section-title small">
          Prüfpunkt ergänzen
        </h2>

        <p class="add-hint">
          Dieser Prüfpunkt gilt nur für diese Messstelle.
          Die Vorlage der Kategorie bleibt unverändert.
        </p>


        <div class="add-row">

          <mat-form-field appearance="outline" class="add-section">

            <mat-label>
              Abschnitt (optional)
            </mat-label>

            <input matInput [(ngModel)]="neuerPunktSection" [disabled]="addingPunkt || savingKategorie"
              placeholder="z.B. Mechanik" />

          </mat-form-field>


          <mat-form-field appearance="outline" class="add-text">

            <mat-label>
              Prüfpunkt
            </mat-label>

            <input matInput [(ngModel)]="neuerPunktText" [disabled]="addingPunkt || savingKategorie"
              (keyup.enter)="addPunkt()" placeholder="z.B. Zusatzprüfung Dichtheit" />

          </mat-form-field>


          <button mat-raised-button color="primary" type="button" [disabled]="
              !neuerPunktText.trim() ||
              addingPunkt ||
              savingKategorie
            " (click)="addPunkt()">

            <mat-icon>
              add
            </mat-icon>

            Hinzufügen

          </button>

        </div>

      </mat-card-content>

    </mat-card>


    <!-- =====================================================
         BILDER

         Ganz unten auf der Seite. Zwei getrennte File-Inputs:
         eines mit capture (öffnet auf Handy/Tablet direkt die
         Kamera), eines ohne (Galerie bzw. Explorer).
         ===================================================== -->
    <mat-card class="section-card">

      <mat-card-content>

        <h2 class="section-title small">

          <mat-icon class="titel-icon">photo_camera</mat-icon>

          Bilder

          <span class="bilder-anzahl" *ngIf="messstelle.bilder?.length">
            {{ messstelle.bilder.length }}
          </span>

        </h2>


        <!-- Aufnehmen oder auswählen -->
        <div class="bilder-upload" *ngIf="canEdit">

          <input #kameraInput type="file" class="datei-input" accept="image/*" capture="environment"
            (change)="onBildAusgewaehlt($event)" />

          <input #galerieInput type="file" class="datei-input" accept="image/*" multiple
            (change)="onBildAusgewaehlt($event)" />


          <button mat-raised-button color="primary" type="button" [disabled]="uploadLaeuft"
            (click)="kameraInput.click()">

            <mat-icon>photo_camera</mat-icon>
            Foto aufnehmen

          </button>


          <button mat-stroked-button type="button" [disabled]="uploadLaeuft" (click)="galerieInput.click()">

            <mat-icon>collections</mat-icon>
            Bild auswählen

          </button>


          <mat-spinner diameter="22" *ngIf="uploadLaeuft"></mat-spinner>

        </div>


        <p class="bilder-fehler" *ngIf="uploadFehler">
          {{ uploadFehler }}
        </p>


        <p class="bilder-leer" *ngIf="!messstelle.bilder?.length">
          Noch keine Bilder vorhanden.
        </p>


        <!-- Vorhandene Bilder -->
        <div class="bilder-grid" *ngIf="messstelle.bilder?.length">

          <div class="bild-karte" *ngFor="let bild of messstelle.bilder; trackBy: trackByBild">

            <div class="bild-flaeche">

              <img *ngIf="bildUrl(bild) as url" class="bild-vorschau" [src]="url"
                [alt]="bild.beschreibung || bild.fileName" (click)="oeffneBild(bild)" />

              <div class="bild-platzhalter" *ngIf="!bildUrl(bild)">
                <mat-spinner diameter="24"></mat-spinner>
              </div>

            </div>


            <!-- Beschreibung / Kommentar -->
            <mat-form-field appearance="outline" class="bild-beschreibung">

              <mat-label>
                Beschreibung
              </mat-label>

              <textarea matInput rows="2" [(ngModel)]="bild.beschreibung"
                [disabled]="!canEdit || istBildSpeichernd(bild.id)" (blur)="saveBildBeschreibung(bild)"
                placeholder="z.B. Typenschild, Einbausituation"></textarea>

            </mat-form-field>


            <div class="bild-fuss">

              <span class="bild-meta">
                {{ bild.uploadedAtUtc | date:'dd.MM.yyyy HH:mm' }}
                <ng-container *ngIf="bild.uploadedByName">
                  · {{ bild.uploadedByName }}
                </ng-container>
                · {{ bildGroesse(bild) }}
              </span>

              <button mat-icon-button type="button" *ngIf="canEdit" [disabled]="istBildSpeichernd(bild.id)"
                (click)="deleteBild(bild)" matTooltip="Bild löschen">

                <mat-icon>delete_outline</mat-icon>

              </button>

            </div>

          </div>

        </div>

      </mat-card-content>

    </mat-card>

    <!-- =====================================================
         GERÄTE-ARTEFAKTE

         Parameterdateien (Backups der Gerätekonfiguration, in
         mehreren Ständen), Zugangsdaten und deren Sicherheits-
         protokoll. Eigene Komponente: der Bereich hat eigene
         Rechte, eigene Ladezustände und einen eigenen Audit-Trail.
         ===================================================== -->
    <app-geraete-artefakte [messstelleId]="messstelle.id"></app-geraete-artefakte>
    <!-- =====================================================
         AKTIVITÄTSVERLAUF

         Jede fachlich relevante Änderung an dieser Messstelle:
         WER hat WANN WAS geändert. Rein lesend – Einträge
         werden nie überschrieben, jede Änderung erzeugt einen
         neuen. Neueste zuerst.
         ===================================================== -->
    <mat-card class="section-card">

      <mat-card-content>

        <h2 class="section-title small">

          <mat-icon class="titel-icon">history</mat-icon>

          Aktivitätsverlauf

          <span class="bilder-anzahl" *ngIf="verlaufGesamt">
            {{ verlaufGesamt }}
          </span>

        </h2>


        <!--
          FILTER

          Alle Filter sind kombinierbar. Online filtert der Server, offline
          dieselbe Logik lokal – der Verlauf einer lange bearbeiteten
          Messstelle wird sonst zu groß, um ihn jedes Mal komplett zu laden.
        -->
        <div class="verlauf-filter">

          <mat-form-field appearance="outline" class="filter-feld filter-schmal">
            <mat-label>Alle Aktivitäten</mat-label>
            <mat-select [(ngModel)]="filterGruppe" (selectionChange)="onFilterGeaendert()">

              <mat-option [value]="null">Alle Aktivitäten</mat-option>

              <mat-option *ngFor="let gruppe of aktivitaetsGruppen" [value]="gruppe.wert">
                {{ gruppe.text }}
              </mat-option>

            </mat-select>
          </mat-form-field>


          <!--
            Angeboten werden nur Personen, die an DIESER Messstelle
            tatsächlich etwas geändert haben.
          -->
          <mat-form-field appearance="outline" class="filter-feld filter-schmal">
            <mat-label>Alle Personen</mat-label>
            <mat-select [(ngModel)]="filterPerson" (selectionChange)="onFilterGeaendert()">

              <mat-option [value]="null">Alle Personen</mat-option>

              <mat-option *ngFor="let person of verlaufPersonen" [value]="person">
                {{ person }}
              </mat-option>

            </mat-select>
          </mat-form-field>


          <mat-form-field appearance="outline" class="filter-feld filter-datum">
            <mat-label>Datum von</mat-label>
            <input matInput [matDatepicker]="vonPicker" [(ngModel)]="filterVon" (dateChange)="onFilterGeaendert()">
            <mat-datepicker-toggle matSuffix [for]="vonPicker"></mat-datepicker-toggle>
            <mat-datepicker #vonPicker></mat-datepicker>
          </mat-form-field>


          <mat-form-field appearance="outline" class="filter-feld filter-datum">
            <mat-label>Datum bis</mat-label>
            <input matInput [matDatepicker]="bisPicker" [(ngModel)]="filterBis" (dateChange)="onFilterGeaendert()">
            <mat-datepicker-toggle matSuffix [for]="bisPicker"></mat-datepicker-toggle>
            <mat-datepicker #bisPicker></mat-datepicker>
          </mat-form-field>


          <!--
            Die Suche ist entprellt: ohne das entstünde je Tastendruck eine
            Anfrage.
          -->
          <mat-form-field appearance="outline" class="filter-feld filter-suche">
            <mat-label>Suche</mat-label>
            <input matInput [(ngModel)]="filterSuche" (ngModelChange)="onSucheGeaendert()"
              placeholder="Feld, Prüfpunkt, Wert …">
            <mat-icon matSuffix>search</mat-icon>
          </mat-form-field>


          <button mat-stroked-button type="button" class="filter-reset" [disabled]="!filterAktiv"
            (click)="filterZuruecksetzen()">
            <mat-icon>filter_alt_off</mat-icon>
            Filter zurücksetzen
          </button>

        </div>


        <p class="bilder-leer" *ngIf="!verlauf.length && !verlaufLaedt">

          <ng-container *ngIf="filterAktiv">
            Zu diesem Filter gibt es keine Aktivitäten.
          </ng-container>

          <ng-container *ngIf="!filterAktiv">
            Noch keine Änderungen protokolliert.
          </ng-container>

        </p>


        <!--
          Ab fünf Einträgen scrollt der Verlauf in sich, statt die Seite
          endlos wachsen zu lassen. Darunter bleibt er ganz sichtbar.
        -->
        <div class="verlauf" *ngIf="verlauf.length" [class.verlauf-scroll]="verlaufScrollt">

          <div class="verlauf-eintrag" [ngClass]="protokollGruppeCss(eintrag)" *ngFor="
              let eintrag of verlauf;
              trackBy: trackByProtokoll
            ">

            <mat-icon class="verlauf-icon">
              {{ protokollIcon(eintrag) }}
            </mat-icon>

            <!--
              Inhalt kommt aus formatAktivitaet() – derselbe Formatter baut
              auch den Prüfverlauf im IBN-PDF.
            -->
            <div class="verlauf-inhalt" *ngIf="protokollAnzeige(eintrag) as anzeige">

              <div class="verlauf-kopf">

                <span class="verlauf-zeit">
                  {{ eintrag.zeitpunktUtc | date:'dd.MM.yyyy HH:mm' }}
                </span>

                <!--
                  Offline erfasst: die Zeit oben ist der TATSÄCHLICHE
                  Änderungszeitpunkt vor Ort. Wann der Eintrag den Server
                  erreicht hat, steht hier daneben – sonst wäre der Verlauf
                  irreführend, weil eine Prüfung von 10:31 als 13:02 erschiene.
                -->
                <span class="verlauf-offline" *ngIf="eintrag.synchronisiertAmUtc" [matTooltip]="'Vor Ort erfasst, synchronisiert am '
                    + (eintrag.synchronisiertAmUtc | date:'dd.MM.yyyy HH:mm')">
                  <mat-icon inline>cloud_done</mat-icon>
                  offline erfasst
                </span>

                <!-- Noch gar nicht beim Server. -->
                <span class="verlauf-offline verlauf-wartet" *ngIf="eintrag.nichtSynchronisiert">
                  <mat-icon inline>cloud_queue</mat-icon>
                  wartet auf Synchronisierung
                </span>

                <span class="verlauf-benutzer" *ngIf="eintrag.benutzerName">
                  {{ eintrag.benutzerName }}
                </span>

              </div>


              <div class="verlauf-titel">
                {{ anzeige.titel }}
              </div>


              <!-- Betroffenes Feld bzw. betroffener Prüfpunkt. -->
              <div class="verlauf-betreff" *ngIf="anzeige.betreff">
                {{ anzeige.betreff }}
              </div>


              <div class="verlauf-ergebnis" *ngIf="anzeige.neuerWert || anzeige.vorherigerWert">

                <span class="verlauf-vorher" *ngIf="anzeige.vorherigerWert">
                  {{ anzeige.vorherigerWert }} →
                </span>

                <span class="verlauf-neu" *ngIf="anzeige.neuerWert">
                  {{ anzeige.neuerWert }}
                </span>

              </div>


              <!-- Zusatz zum Vorgang, z. B. "Bereich: Funktionsprüfung". -->
              <div class="verlauf-zusatz" *ngIf="anzeige.zusatz">
                {{ anzeige.zusatz }}
              </div>


              <div class="verlauf-bemerkung" *ngIf="anzeige.bemerkung">
                „{{ anzeige.bemerkung }}“
              </div>

            </div>

          </div>

        </div>


        <div class="verlauf-mehr" *ngIf="verlaufHatMehr || verlaufLaedt">

          <button mat-stroked-button type="button" [disabled]="verlaufLaedt" (click)="ladeVerlauf(true)">
            {{ verlaufLaedt ? 'Wird geladen …' : 'Weitere anzeigen' }}
          </button>

          <span class="verlauf-zaehler" *ngIf="verlaufGesamt">
            {{ verlauf.length }} von {{ verlaufGesamt }}
          </span>

        </div>

      </mat-card-content>

    </mat-card>
  </ng-container>

</div>